import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class UserList extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						User List
					</div>
					<div>
						<DownloadFile title="Download UserList Dump" url="login/user-dump"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="login/add-user"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/UserList/Components/UserList.js